export enum RevisionItemCategory {
  BASIC = "BASIC",
  SPECIFIC = "SPECIFIC"
}